import React, { FunctionComponent } from 'react';

import { useFlags } from '../../hooks';

import './MemberList.scss';
import LeaderBoardMembersList from './LeaderBoardMembersList';
import LegacyMembersList from './LegacyMembersList';
import { TeamInviteShare } from '../SocialButtons/TeamInviteShare';

export type MemberListProps = {
  listRef: React.RefObject<HTMLElement>;
};

const MembersList: FunctionComponent<MemberListProps> = props => {
  const flags = useFlags();
  const { listRef } = props;

  return (
    <TeamInviteShare>
      {flags.useLeaderboardFundraisersListForTeams ? (
        <LeaderBoardMembersList listRef={listRef} />
      ) : (
        <LegacyMembersList listRef={listRef} />
      )}
    </TeamInviteShare>
  );
};

export default MembersList;
